import React from 'react';
import PropTypes from 'prop-types';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import VM from 'scratch-vm';

import { saveProject, updateProject } from '../lib/http';

import { setShareWorkInfo, showSaveDialog } from '../reducers/project-state-modify';

import { getIsAnyCreatingNewState } from '../reducers/project-state';

import { getParameterByName } from '../lib/tool';

const homeWorkParams = (() => {
    let customerBookingId = getParameterByName('customerBookingId');
    let customerId = getParameterByName('customerId');
    let examPaperId = getParameterByName('examPaperId');
    let examPaperQuestionId = getParameterByName('examPaperQuestionId');
    let materialId = getParameterByName('materialId');
    return {
        customerBookingId,
        customerId,
        examPaperId,
        examPaperQuestionId,
        materialId
    }
})()

const ProjectSaverHOCModify = (WrappedComponent) => {
    class ProjectSaverModify extends React.Component {
        constructor(props) {
            super(props);
            bindAll(this, [
                'onUpdateProjectData',
                'onShare',
                'saveOrUpdate',
                'readProjectFile',
                'getWorkParams',
                'saveWorkToLocalStorage'
            ])
        }

        saveWorkToLocalStorage() {
            const { projectTitle } = this.props;
            localStorage.setItem('projectName', projectTitle);
            return this.readProjectFile().then(content => {
                return localStorage.setItem('projectFile', content);
            })
        }

        getCoverInfo() {
            return new Promise((resolve) => this.props.vm.renderer.requestSnapshot(dataURI => resolve(dataURI))).catch(err => reject(err))
        }

        readProjectFile() {
            return new Promise((resolve, reject) => {
                this.props.vm.saveProjectSb3().then(content => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        let filterResult = reader.result && reader.result.replace(/^data:\S+base64,/, '')
                        resolve(filterResult);
                    };
                    reader.onerror = () => {
                        reject('project-saver-hoc-modify：保存文件时，文件转换错误！')
                    }
                    reader.readAsDataURL(content);
                })
            });
        }

        onUpdateProjectData(projectId) {
            return this.readProjectFile().then(content => {
                return this.getWorkParams(projectId, content)
            })
        }

        getWorkParams(projectId, content) {
            const { shareWork, projectName } = this.props;
            const defaultParams = {
                coverFile: '',
                id: projectId || '',
                keyboardType:  0,
                projectDescription: '',
                projectFile: content || '',
                projectName: projectName  || "Scratch项目",
                projectVersion: 's3.0',
                ...homeWorkParams
            }

            return this.getCoverInfo().then(dataURI => {
                this.props.setShareWorkInfo('coverFile', dataURI);
                const params = {
                    ...defaultParams,
                    coverFile: dataURI
                }
                return this.saveOrUpdate(params);
            })
        }

        saveOrUpdate(params) {
            const { shareWork } = this.props;
            if (params.id) {
                const updateParams = {
                    ...params,
                    projectDescription: '',
                }
                return updateProject(updateParams);
            } else {
                return saveProject(params);
            }
        }

        onShare() {
            this.getCoverInfo().then(dataURI => {
                this.props.setShareWorkInfo('coverFile', dataURI);
            })
            this.props.showSaveDialog(true);
        }

        render() {

            const {
                shareWork,
                showSaveDialog,
                setShareWorkInfo,
                isLoading,
                projectTitle,
                projectName,
                ...componentProps
            } = this.props;

            const props = {
                onShare: this.onShare,
                onUpdateProjectData: this.onUpdateProjectData,
                saveWorkToLocalStorage: this.saveWorkToLocalStorage,
                ...componentProps
            }

            return (
                <WrappedComponent
                    {...props}
                />
            )
        }
    }

    ProjectSaverModify.propTypes = {
        vm: PropTypes.instanceOf(VM).isRequired
    }

    const mapStateToProps = state => {
        const loadingState = state.scratchGui.projectState.loadingState;
        return {
            vm: state.scratchGui.vm,
            projectTitle: state.scratchGui.projectTitle,
            shareWork: state.scratchGui.shareWork,
            projectName: state.scratchGui.projectTitle,
            isAnyCreatingNewState: getIsAnyCreatingNewState(loadingState)
        }
    };

    const mapDispatchToProps = dispatch => ({
        setShareWorkInfo: (key, value) => dispatch(setShareWorkInfo(key, value)),
        showSaveDialog: boolean => dispatch(showSaveDialog(boolean))
    });

    return connect(
        mapStateToProps,
        mapDispatchToProps
    )(ProjectSaverModify)
}

export default ProjectSaverHOCModify;
